/**
 * PRODUCTION LINK.
 */
const baseUrlTrimitraIAM = "https://01z4tn3758.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlOtodis = "https://c1dbgj7gv9.execute-api.ap-southeast-1.amazonaws.com/otodis";
const baseUrlApiOtodis = "https://v0b1z99035.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlOtodisDocument = "https://35tt91zxme.execute-api.ap-southeast-1.amazonaws.com/otodis";
const baseUrlCatalog = "https://zvu1c5uoue.execute-api.ap-southeast-1.amazonaws.com/v1/";
const baseUrlAutotrimitra = "https://au-api-trimitra-get-65q45htc.ts.gateway.dev";
const baseUrlBiro = "https://2rtwh7ezy0.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlAmren = "https://c1dbgj7gv9.execute-api.ap-southeast-1.amazonaws.com/otodis"; //"https://amren.id";
const baseUrlOffer = "https://42cjbxpaa8.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlGeneralOffer = "https://0vndxposq6.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlAutoClosingOfferGcp = "https://asia-southeast1-autotrimitra.cloudfunctions.net/api-offer-otodis--scheduler";
const baseUrlDdms = "https://asia-southeast2-autotrimitra.cloudfunctions.net/otodis__DDMS_document-GET";
const baseUrlBqFinalSale = "https://asia-southeast2-autotrimitra.cloudfunctions.net/otodis__final_sales_BQ/v2";
const baseUrlIdeal = "https://asia-southeast2-ideal-trimitra.cloudfunctions.net/ideal-backend";
const baseUrlCdnUpload = "https://hbxhwzeej9.execute-api.ap-southeast-1.amazonaws.com/v1";
const baseUrlBengkel = "https://asia-southeast1-autotrimitra.cloudfunctions.net/purchase-order-part/";
const baseUrlRobofin = "https://api.robofin.com/";
const baseUrlCloudFunc = "https://asia-southeast2-autotrimitra.cloudfunctions.net";
const baseUrlPromo = "https://80pj23grqd.execute-api.ap-southeast-1.amazonaws.com/v1";

/**
 * APIKEY LINK.
 */
const xApiKeyOtodis = "mIUqA1twNs6dkGUtt80Lp3rpKJfH9oc69BGwPLAU";
const xApiKeyCatalog = "pkCMWw9DsT9uz48TCFClQ7c6eCtwR3rp3zIaIFDi";
const xApiKeyOffer = "9bekwohY878MgiMsRL0Wk2Xsgv4QsxtW4jEIuBqb";
const xApiKeyGeneralOffer = "GyEnzcc3vm1MvwB5Y20K31OT5ylcW6wh7l2ilxiI";
const xApiKeyRobofin = "MefURHB3fKLhNkuKEsVkIpRCf4sp3m2f";
const xApiKeyPromo = 'itMzx2LEJU2VtfzkBsZXs7U4p2ScXXXn4qY3Xdbw';
const xApiKeyCdnUpload = "zXSa4iZwycS0O5kaoMvi2yAFiIpimTZ55MvvJLy0";

export {
    baseUrlCloudFunc,
    baseUrlOtodis,
    baseUrlApiOtodis,
    baseUrlOtodisDocument,
    baseUrlAutoClosingOfferGcp,
    baseUrlAutotrimitra,
    baseUrlTrimitraIAM,
    baseUrlBiro,
    baseUrlAmren,
    baseUrlCatalog,
    baseUrlOffer,
    xApiKeyOtodis,
    xApiKeyCatalog,
    xApiKeyOffer,
    baseUrlDdms,
    baseUrlBqFinalSale,
    baseUrlIdeal,
    baseUrlCdnUpload,
    baseUrlBengkel,
    baseUrlRobofin,
    xApiKeyRobofin,
    xApiKeyCdnUpload,
    baseUrlGeneralOffer,
    xApiKeyGeneralOffer,
    baseUrlPromo,
    xApiKeyPromo
};
